import { render, staticRenderFns } from "./AdviceYN.vue?vue&type=template&id=59afe0ab"
import script from "./AdviceYN.vue?vue&type=script&lang=js"
export * from "./AdviceYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports